/* app/js/src/components/clipping-studio/panels/media-panel/mam-media-card/clipping-studio-mam-media-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  min-width: 0;
}
.mam-media-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  padding: 8px 0;
  border-bottom: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  cursor: pointer;
  transition: background 0.15s ease;
}
.mam-media-card:last-child {
  border-bottom: none;
}
.mam-media-card:hover {
  background: rgba(0, 0, 0, 0.04);
}
.mam-media-card:hover .mam-media-card__add-btn {
  opacity: 1;
}
.mam-media-card__thumbnail {
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 45px;
  overflow: hidden;
  background: rgba(35, 47, 58, 0.05);
}
.mam-media-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.mam-media-card__placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(35, 47, 58, 0.05);
}
.mam-media-card__placeholder-text {
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.mam-media-card__duration {
  position: absolute;
  left: 2px;
  bottom: 2px;
  padding: 2px 4px;
  font-size: 9px;
  letter-spacing: 0.1px;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
}
.mam-media-card__info {
  flex: 1;
  min-width: 0;
  padding: 0 4px 0 0;
}
.mam-media-card__title {
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mam-media-card__duration-inline {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 2px;
}
.mam-media-card__add-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  border-radius: 4px;
  cursor: pointer;
  opacity: 0;
  transition:
    opacity 0.15s ease,
    background 0.15s ease,
    border-color 0.15s ease;
}
.mam-media-card:hover .mam-media-card__add-btn {
  opacity: 1;
}
.mam-media-card__add-btn:hover {
  background: rgb(45, 187, 252);
  border-color: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
}
.mam-media-card__add-icon {
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
}
/*# sourceMappingURL=clipping-studio-mam-media-card.component.css.map */
